(function(angular) {
  'use strict';

  var app = angular.module('asSupplyMgr');

  app.controller('DealEditController', [
    '$scope',
    '$window',
    'dealApi',
    function($scope, $window, dealApi) {
      // init values
      $scope.deal = {
        name: '',
      };

      $scope.log = {
          count: 0,
          data: [],
      };


        // load deal from server
      if ($window.dealId) {
        dealApi.read($window.dealId).then(
          data => {
            $scope.deal = data.deal;
            $scope.log = data.log;
          },
          () => {
            console.error('could not load deal');
          }
        );
      }

      // try saving and process server side validation errors
      $scope.submitForm = () => {
        dealApi.save($scope.deal).then(
          () => {
            $window.location.href = '/#!/supply/deal';
          },
            data => {
                defaultSaveErrorHandler($scope.dealForm, data);
          }
        );
      };
    },
  ]);
})(window.angular);

/**
 * List Controller
 */
(function(angular) {
  'use strict';

  let app = angular.module('asSupplyMgr');

  app.controller('DealIndexController', [
    '$scope',
    'dealApi',
    function($scope, dealApi) {
      // select search input content on focus
      $('#search').click(function() {
        $(this).select();
      });

      $scope.loading = false;

      $scope.list = null;

      $scope.page = {
        number: 0,
        size: 500,
      };

      $scope.searchTerm = '';

      $scope.sort = {
        field: 'name',
        order: 'asc',
      };

      /**
       * If user presses enter in search box perform the search
       * @param e
       */
      $scope.checkSubmit = function(e) {
        if (e.originalEvent.charCode === 13) {
          $scope.search();
        }
      };

      $scope.search = function() {
        $scope.page.number = 0;

        $scope.fetch();
      };

      /**
       * Fetch list data from server
       */
      $scope.fetch = function() {
        $scope.loading = true;

        dealApi.getList($scope.sort, $scope.searchTerm, $scope.page).then(
          function(data) {
            $scope.list = {
              count: data.count,
              data: data.data,
              maxPage: Math.floor(data.count / $scope.page.size),
            };
            $scope.loading = false;
          },
          function() {
            $scope.list = {
              count: 0,
              data: [],
              maxPage: null,
            };
            $scope.loading = false;
          }
        );
      };

      /**
       * set page to new value and load data
       * @param page
       */
      $scope.setPage = function(page) {
        $scope.page.number = page;

        $scope.fetch();
      };

      /**
       * get the sort css for a given column
       * @param field
       * @returns {*}
       */
      $scope.getSortCssClass = function(field) {
        if ($scope.sort.field === field) {
          return 'fa-sort-' + $scope.sort.order;
        } else {
          return 'fa-sort';
        }
      };

      /**
       * update sorting and fetch data
       * @param field
       */
      $scope.setSort = function(field) {
        $scope.page.number = 0;

        if ($scope.sort.field === field) {
          $scope.sort.order = $scope.sort.order === 'desc' ? 'asc' : 'desc';
        } else {
          $scope.sort.field = field;
          $scope.sort.order = 'desc';
        }

        $scope.fetch();
      };

      /**
       * show the delete confirmation dialog
       * @param advertiser
       */
      $scope.promptDelete = function(deal) {
        $scope.dealToDelete = deal;
        $('#delete-modal').modal('show');
      };

      /**
       * delete an IO
       * @param io
       */
      $scope.delete = function(deal) {
        dealApi.delete(deal.id).then(function() {
          $scope.fetch();
        });
      };

      /**
       * export list to csv
       */
      $scope.export = function() {
        let url = '/supply/deal/export' + getReportUrl($scope.sort, $scope.searchTerm);

        window.location.href = url;
      };

      $scope.fetch();
    },
  ]);
})(window.angular);
